import script from "./ModalPayInvoice.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPayInvoice.vue?vue&type=script&setup=true&lang=js"

import "./ModalPayInvoice.vue?vue&type=style&index=0&id=04e6cd94&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e6cd94"]])

export default __exports__